import { IPromo } from './promos.types'
import { ITableField } from '../../shared/Table'

const promoTableFields: Array<ITableField<IPromo, keyof IPromo>> = [
  {
    key: 'code',
    header: 'Код',
    getter: (answer) => answer.code || '-',
    sortGetter: (answer) => answer.code || '-',
    width: '150px',
  },
  {
    key: 'title',
    header: 'Ссылка',
    getter: (answer) => answer.title || '-',
    sortGetter: (answer) => answer.title || '-',
    width: '100px',
  },
  {
    key: 'usedCount',
    header: 'Кол-во покупок',
    getter: (answer) => answer.usedCount?.toString() || '-',
    sortGetter: (answer) => answer.usedCount || '-',
    width: '100px',
  },
  {
    key: 'description',
    header: 'Описание',
    getter: (answer) => answer.description || '-',
    sortGetter: (answer) => answer.description,
    width: '200px',
  },
  {
    key: 'discount',
    header: 'Скидка',
    getter: (answer) => (answer.discount * 100).toFixed(2) + '%',
    sortGetter: (answer) => answer.discount,
    width: '100px',
  },
  {
    key: 'expired',
    header: 'Дата окончания',
    getter: (answer) => new Date(answer.expired).toLocaleDateString(),
    sortGetter: (answer) => new Date(answer.expired).getTime(),
    width: '100px',
  },
]

export default promoTableFields
